<template>
    <div>
        <div v-if = "header">
            <div class="navigation-header pr-2 panel-width">
                <div class = "navigation-col-header remove-button pl-4">
                    <v-icon >mdi-trash-can-outline</v-icon>
                </div>
                <div class = "navigation-col-header elevator">
                    {{ $t('inc.unit.elevatorNo') }}
                </div>
                <div class = "navigation-col-header executionDate pl-2">
                    Ausf. Datum
                </div>
                <div class = "navigation-col-header description pl-2">
                    {{ $t('inc.edit.general.description') }}
                </div>
                <div class = "navigation-col-header measure pl-2">
                    {{ $t('inc.edit.general.measure') }}
                </div>
            </div>
        </div>

        <v-hover
            v-if   = "!header"
            v-slot = "{ hover }"
        >
            <div
                v-if="unit"
                class="navigation-entry panel-width"
                :class ="border2"
            >
                <div
                    class="remove-button"
                    :class = "background(hover)"
                >
                    <a @click="onRemove">
                        <v-icon color="error" class="toolbar-button" size="20">mdi-minus-box</v-icon>
                    </a>
                </div>
                <div
                    class  = "elevator"
                    :class = "background(hover)"
                >
                    {{ unit.fabricNo }}
                </div>
                <div
                    class  = "executionDate"
                    :class = "background(hover)"
                >
                    {{ executionDate }}
                </div>
                <div
                    class  = "description"
                    :class = "background(hover)"
                >
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <div
                                class="text-cell"
                                v-bind = "attrs"
                                v-on   = "on"
                            >
                                {{ description }}
                            </div>
                        </template>
                        <span v-html="description"></span>
                    </v-tooltip>
                </div>
                <div
                    class  = "measure"
                    :class = "background(hover)"
                >
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <div
                                class="text-cell"
                                v-bind = "attrs"
                                v-on   = "on"
                            >
                                {{ result }}
                            </div>
                        </template>
                    <span v-html="result"></span>
                    </v-tooltip>
                </div>
            </div>
        </v-hover>
    </div>
</template>

<script>

import PIncNavigationMixin from "@/modules/inc/steps/components/navigation/private/PIncNavigationMixin";

export default {
    name: "PIncNavigationEntryMaintenance",

    components: {
    },

    props: {
        stepData: {

        }
    },

    mixins: [
        PIncNavigationMixin
    ],

    computed: {
        executionDate () {
            return this.dateAsString(this.stepData.executiondate);
        },

        description () {
            if (!this.entry.description) {
                return "---";
            }

            return this.toHtml(this.entry.description);
        },

        result () {
            if (! this.entry.result) {
                return "---";
            }

            return this.toHtml(this.entry.result);
        },
    },
}
</script>

<style scoped>

.panel-width {
    max-width: 750px;
    min-width: 750px;
    width: 750px;
}

.executionDate {
    width: 13%;
    max-width: 13%;
    text-align: left;
}

.description, .measure {
    width: 31%;
    max-width: 31%;
    text-align: left;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

}

.executionDate, .description, .measure, .elevator {
    font-size: 15px;
    padding-top: 5px;
    padding-right: 8px;
}

.text-cell {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}


</style>